/**
 * Created by ivantchourilov on 16/04/15.
 */

'use strict';
{
    var app = angular.module('tf.directives', [])

        .directive("disableAnimate", ['$animate', function ($animate) {
            return function (scope, element) {
                $animate.enabled(element, false);
            };
        }])

        .directive('vertilizeContainer', [
            function () {
                return {
                    restrict: 'EA',
                    controller: [
                        '$scope', '$window',
                        function ($scope, $window) {
                            // Alias this
                            var _this = this;

                            // Array of children heights
                            _this.childrenHeights = [];

                            // API: Allocate child, return index for tracking.
                            _this.allocateMe = function () {
                                _this.childrenHeights.push(0);
                                return (_this.childrenHeights.length - 1);
                            };

                            // API: Update a child's height
                            _this.updateMyHeight = function (index, height) {
                                _this.childrenHeights[index] = height;
                            };

                            // API: Get tallest height
                            _this.getTallestHeight = function () {
                                var height = 0;
                                for (var i = 0; i < _this.childrenHeights.length; i = i + 1) {
                                    height = Math.max(height, _this.childrenHeights[i]);
                                }
                                return height;
                            };

                            // Add window resize to digest cycle
                            angular.element($window).bind('resize', function () {
                                return $scope.$apply();
                            });
                        }
                    ]
                };
            }
        ])

        // Vertilize Item
        .directive('vertilize', [
            function () {
                return {
                    restrict: 'EA',
                    require: '^vertilizeContainer',
                    link: function (scope, element, attrs, parent) {
                        // My index allocation
                        var myIndex = parent.allocateMe();

                        // Get my real height by cloning so my height is not affected.
                        var getMyRealHeight = function () {
                            var clone = element.clone()
                                .removeAttr('vertilize')
                                .css({
                                    height: '',
                                    width: element.outerWidth(),
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    visibility: 'hidden'
                                });
                            element.after(clone);
                            var realHeight = clone.height();
                            clone['remove']();
                            return realHeight;
                        };

                        // Watch my height
                        scope.$watch(getMyRealHeight, function (myNewHeight) {
                            if (myNewHeight) {
                                parent.updateMyHeight(myIndex, myNewHeight);
                            }
                        });

                        // Watch for tallest height change
                        scope.$watch(parent.getTallestHeight, function (tallestHeight) {
                            if (tallestHeight) {
                                element.css('height', tallestHeight);
                            }
                        });
                    }
                };
            }
        ])

        .directive('masonry', ['$timeout', function ($timeout) {
            return {
                restrict: 'AC',
                link: function (scope, elem, attrs) {
                    scope.$watch(function () {
                            return elem[0].children.length
                        },

                        function (newVal) {
                            $timeout(function () {
                                elem.masonry('reloadItems');
                                elem.masonry();
                            })
                        })

                    elem.masonry({
                        itemSelector: '.item'
                    });
                    scope.masonry = elem.data('masonry');
                }
            };

        }])

        .directive('postcode', ['$q', '$http', function ($q, $http) {
            return {
                restrict: 'A',
                scope: {
                    state: "=?postcodeState",
                    stateEvent: "&?onPostcodeState"
                },
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {


                    ctrl.$asyncValidators.postcode = function (modelValue, viewValue) {

                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            scope.state = null;
                            return $q.when();
                        }

                        var def = $q.defer();

                        $http.post('/tradefloor/api/validate/postcode', modelValue, {ignoreError: true}).then(function (response) {
                            if (scope.state) {
                                scope.state = response.data;
                            }
                            if (scope.stateEvent) {
                                scope.stateEvent({state: response.data});
                            }
                            def.resolve();
                        }, function () {
                            if (scope.state) {
                                scope.state = null;
                            }
                            if (scope.stateEvent) {
                                scope.stateEvent({state: null});
                            }
                            def.reject();
                        });

                        return def.promise;
                    };
                }
            };
        }])

        .directive("leagueName", ['$q', "$http", function ($q, $http) {
            return {
                restrict: "A",
                require: 'ngModel',
                link: function ($scope, $elem, $attr, ngModel) {

                    ngModel.$asyncValidators.leagueName = function (modelValue) {
                        if (ngModel.$isEmpty(modelValue)) {
                            return $q.resolve();
                        }

                        var deferred = $q.defer();

                        $http.get('/tradefloor/api/leaderboards/' + modelValue + '/exists')
                            .then(function (response) {
                                var data = response.data;
                                data.exists ? deferred.reject() : deferred.resolve()
                            });

                        return deferred.promise;
                    }
                }
            }
        }])

        .directive('userAlias', ['$q', '$http', function ($q, $http) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {

                    const badAlias = "bad-alias";
                    const aliasConflict = "alias-conflict";

                    ctrl.$asyncValidators.alias = function (modelValue, viewValue) {

                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return $q.when();
                        }

                        var def = $q.defer();

                        $http.post('/tradefloor/api/validate/user/alias', modelValue, {ignoreError: true}).then(function (response) {
                            ctrl.$setValidity(badAlias, true);
                            ctrl.$setValidity(aliasConflict, true);
                            def.resolve();
                        }, function (error) {
                            if (error.status === 400) {
                                ctrl.$setValidity(badAlias, false);
                                ctrl.$setValidity(aliasConflict, true);
                                def.reject();
                            } else if (error.status === 409) {
                                ctrl.$setValidity(badAlias, true);
                                ctrl.$setValidity(aliasConflict, false);
                                def.reject();
                            } else {
                                ctrl.$setValidity(badAlias, true);
                                ctrl.$setValidity(aliasConflict, true);
                                def.reject();
                            }
                        });

                        return def.promise;
                    };
                }
            };
        }])

        //hack to get ui-bootstrap to work with touch

        .directive('stopEvent', [function () {
            return {
                restrict: 'A',
                link: function (scope, element, attr) {
                    element.on(attr.stopEvent, function (e) {
                        e.stopPropagation();
                    });
                }
            };
        }])

        .directive('contenteditable', ['$sce', function ($sce) {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModel) {
                    if (!ngModel) return; // do nothing if no ng-model

                    // Specify how UI should be updated
                    ngModel.$render = function () {
                        elm.html(ngModel.$viewValue || '');
                    };


                    elm.on('blur', function (event) {
                        scope.$evalAsync(read);
                    });

                    // Listen for change events to enable binding
                    elm.on('keydown', function (event) {

                        if (event.which == 27) {
                            ngModel.$render();
                            elm.blur();
                            event.preventDefault();
                        } else if (event.which == 13) {
                            elm.blur();
                            event.preventDefault();
                        }
                    });

                    // Write data to the model
                    function read() {
                        var html = elm.html();
                        html = html.replace(/<br>$/, '')
                            .replace(/<div>/g, '').replace(/<br>/g, '').replace(/<\/div>/g, '')
                            .replace(/<\S[^><]*>/g, '')
                            .replace(/&nbsp;/g, '')
                            .replace(/&amp;/g, '&')
                            .replace(/&gt;/g, '>')
                            .replace(/&lt;/g, '<');

                        ngModel.$setViewValue(html);
                    }


                }
            };
        }])

        .directive('fixedFirstColumn', [function () {
            return {
                restrict: "A",
                template: "<div class='table-responsive'><div ng-transclude></div></div>",
                transclude: true,
                link: function ($scope, $element) {
                    var interval = setInterval(function () {
                        var tr = $element.find("tr");

                        angular.forEach(tr, function (i) {
                            var columns = angular.element(i).children();

                            if (columns.length < 1) {
                                // Row with no columns? Ignore it.
                                return;
                            }

                            var column0 = angular.element(columns[0]).children()[0] || columns[0];
                            var column1 = columns[1];

                            // Calculate heights of each <td>.
                            var height0 = (column0).offsetHeight;
                            var height1 = column1 ? column1.offsetHeight : 0;

                            // Calculate final height.
                            var height = Math.max(height0, height1);

                            // Set heights of <td> and <tr>.
                            columns[0].style.height = height + "px";
                            i.style.height = height + "px";

                            if (column1) {
                                column1.style.height = height + "px";
                            }

                            // If <td> heights have stabilized.
                            if (height0 !== 0 && height0 === height1) {
                                clearInterval(interval);
                            }
                        });
                    }, 1000);
                }
            }
        }])

        // AngularJS directives for jquery sparkline
        .directive('jqSparkline', [function () {
            'use strict';
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, elem, attrs, ngModel) {

                    var opts = {};
                    //TODO: Use $eval to get the object
                    opts.type = attrs.type || 'bar';

                    scope.$watch(attrs.ngModel, function () {
                        render();
                    });

                    scope.$watch(attrs.opts, function () {
                            render();
                        }
                    );
                    var render = function () {
                        var model;
                        if (attrs.opts) angular.extend(opts, scope.$eval(attrs.opts));
                        if (!opts.numberFormatter) {
                            opts.numberFormatter = function (input) {
                                var numberStyle = {
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                };
                                return input.toLocaleString(undefined, numberStyle);
                            };
                        }

                        // Trim trailing comma if we are a string
                        angular.isString(ngModel.$viewValue) ? model = ngModel.$viewValue.replace(/(^,)|(,$)/g, "") : model = ngModel.$viewValue;
                        var data;
                        // Make sure we have an array of numbers
                        angular.isArray(model) ? data = model : data = model.split(',');
                        $(elem).sparkline(data, opts);
                    };
                }
            }
        }])

        .directive('calHeatmap', [function () {
            function link(scope, el) {
                var config = scope.config || {};
                var element = el[0];
                var cal = new CalHeatMap();
                var defaults = {
                    itemSelector: element,
                    domain: 'month',
                    subDomain: 'day',
                    data: '',
                    start: new Date(),
                    cellSize: 25,
                    range: 3,
                    domainGutter: 10,
                    legend: [2, 4, 6, 8, 10],
                    itemName: 'item'
                };
                angular.extend(defaults, config);
                cal.init(defaults);
                scope.$watch('data', function (data) {
                    cal.update(data);
                });
            }

            return {
                template: '<div class="cal-heatmap" config="config"></div>',
                restrict: 'E',
                link: link,
                scope: {
                    config: '=',
                    data: '='
                }
            };
        }])

        .directive('tabsetMinimised', [function () {
            return {
                restrict: 'EA',
                transclude: true,
                replace: true,
                scope: {
                    type: '@'
                },
                controller: 'TabsetController',
                templateUrl: 'template/tabs/tabsetMinimised.html',
                link: function (scope, element, attrs) {
                    scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
                    scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
                }
            };
        }])

        //.directive( 'popoverHtmlPopup', [ function() {
        //    return {
        //        restrict: 'EA',
        //        replace: true,
        //        scope: { title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
        //        template:
        //            '<div class="popover {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">' +
        //            '<div class="arrow"></div>' +
        //            '<div class="popover-inner">' +
        //            '<h3 class="popover-title" ng-bind="title" ng-show="title"></h3>' +
        //            '<div class="popover-content" bind-html-unsafe="content"></div>' +
        //            '</div>' +
        //            '</div>'
        //    };
        //}])
        //
        //.directive( 'popoverHtml', [ '$compile', '$timeout', '$parse', '$window', '$tooltip', function ( $compile, $timeout, $parse, $window, $tooltip ) {
        //    return $tooltip( 'popoverHtml', 'popover', 'mouseenter' );
        //}])

        .directive('term', ['$rootScope', '$compile', 'userConfig', function ($rootScope, $compile, userConfig) {

            return {
                restrict: 'A',
                replace: true,
                terminal: true,
                priority: 1000,
                link: link
            };

            function link(scope, element, attrs) {

                element.removeAttr('term');
                element.removeAttr('data-term');

                if (userConfig.contextHelp) {
                    var term = attrs['term'] || attrs['data-term'];
                    if (!term) {
                        $compile(element)(scope);

                        return;
                    }

                    element.attr('uib-popover-html', term + '.description');
                    element.attr('popover-popup-delay', 750);
                    //element.attr('popover-append-to-body', true);
                    element.attr('popover-trigger', '\'mouseenter\'');

                    element.attr('popover-placement', 'bottom');
                    element.addClass('term');
                }

                $compile(element)(scope);
            }
        }])

        .directive("valueNotZero", [function () {
            return {
                restrict: "A",
                require: "ngModel",
                link: ($scope, $elem, $attr, ngModel) => {

                    let disabled = false;

                    // Watch the model value of ngModel
                    const watchValue = () => ngModel.$modelValue;

                    const key = $attr["valueNotZero"];
                    const validationKey = `value-not-zero-${key}`;
                    const watch = $scope.$watch(watchValue, (newVal) => {
                        if (disabled) {
                            ngModel.$setValidity(validationKey, true);
                        } else {
                            const modelValue = Number(newVal);
                            if (newVal == null) {
                                ngModel.$setValidity(validationKey, true)
                            } else if (modelValue === 0) {
                                ngModel.$setValidity(validationKey, false)
                            } else {
                                ngModel.$setValidity(validationKey, true)
                            }
                        }
                    });

                    const disabledWatch = $scope.$watch($attr["valueNotZeroDisabled"], (value) => {
                        disabled = value;
                        if (disabled) {
                            ngModel.$setValidity(validationKey, true);
                        }
                    });

                    $scope.$on("$destroy", () => {
                        ngModel.$setValidity(validationKey, true);
                        watch();
                        disabledWatch();
                    });
                }
            }
        }])
         .directive('namevalidation', ['$q', '$http', function ($q, $http) {
             var NAME_REGEXP = /^[a-zA-Z]+$/;
             return {
                 require: 'ngModel',
                 link: function(scope, elm, attrs, ctrl) {
                     ctrl.$validators.namevalidation = function(modelValue, viewValue) {
                         if (ctrl.$isEmpty(modelValue)) {
                             // consider empty models to be valid
                             return true;
                         }

                         if (NAME_REGEXP.test(viewValue)) {
                             // it is valid
                             return true;
                         }

                         // it is invalid
                         return false;
                     };
                 }
             };
        }]);
}
